"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kumamonEgg = {
    name: "kumamon",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["k", "u", "m", "a", "m", "o", "n"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://weichiachang.github.io/easter-eggs-mobile/images/kumamon.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "400px";
        img.style.height = "500px";
        img.style.transition = "10s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 200px)";
        img.style.bottom = "-200px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "0px";
        }, 30);
        window.setTimeout(function () {
            img.style.bottom = "-600px";
        }, 18300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 30400);
    },
};
exports.default = kumamonEgg;
